import { useContext, useMemo } from 'react'
import { HLSContext } from '../../context/hlsContext'
import { ViddyLPContext } from '../../context/viddyLPContext'
import { useHLSManager } from '../../hooks/useHlsManager'

export const HLSProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const {
        landingPage: { defaultPlaylist: playlist },
    } = useContext(ViddyLPContext)
    const videos = useMemo(() => {
        if (!playlist) return []
        return [playlist.videos]
    }, [playlist])
    const { setVideoElementRef, resetVideoLoc, hlsInstances, detachAll } =
        useHLSManager(videos)
    const hlsContextStore = useMemo(
        () => ({
            setVideoElementRef,
            resetVideoLoc,
            hlsInstances,
            detachAll,
        }),
        [detachAll, hlsInstances, resetVideoLoc, setVideoElementRef],
    )

    return (
        <HLSContext.Provider value={hlsContextStore}>
            {children}
        </HLSContext.Provider>
    )
}
